import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SKor2424Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SKor2424IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_1813_1021)">
        <path d="M2 4H22V19H2V4Z" fill="white" />
        <path
          d="M15.746 7.16252L15.2777 7.47349L16.1358 8.75474L16.6041 8.44377L15.746 7.16252Z"
          fill="black"
        />
        <path
          d="M16.7609 8.67672L16.2927 8.98769L17.1507 10.2678L17.619 9.95797L16.7609 8.67672Z"
          fill="black"
        />
        <path
          d="M16.4491 6.69644L15.9804 7.0073L17.8531 9.80245L18.3218 9.49159L16.4491 6.69644Z"
          fill="black"
        />
        <path
          d="M17.1495 6.23152L16.6818 6.54177L17.5401 7.82261L18.0078 7.51236L17.1495 6.23152Z"
          fill="black"
        />
        <path
          d="M18.1643 7.74522L17.6957 8.05608L18.5539 9.33693L19.0225 9.02607L18.1643 7.74522Z"
          fill="black"
        />
        <path
          d="M6.85073 13.0635L6.38207 13.3743L8.25537 16.1704L8.72403 15.8595L6.85073 13.0635Z"
          fill="black"
        />
        <path
          d="M6.14694 13.53L5.67973 13.8402L6.53782 15.1214L7.00503 14.811L6.14694 13.53Z"
          fill="black"
        />
        <path
          d="M7.16179 15.0434L6.69354 15.3544L7.55163 16.6356L8.01988 16.3247L7.16179 15.0434Z"
          fill="black"
        />
        <path
          d="M5.44512 13.9952L4.97736 14.3061L6.8492 17.1009L7.31781 16.79L5.44512 13.9952Z"
          fill="black"
        />
        <path
          d="M8.25511 7.16362L6.38211 9.95907L6.85036 10.2689L8.72225 7.47349L8.25511 7.16362Z"
          fill="black"
        />
        <path
          d="M7.55181 6.69757L5.67973 9.49206L6.14798 9.80303L8.01988 7.00758L7.55181 6.69757Z"
          fill="black"
        />
        <path
          d="M6.84898 6.23158L4.97765 9.0274L5.44642 9.33804L7.31775 6.54221L6.84898 6.23158Z"
          fill="black"
        />
        <path
          d="M16.1358 14.5786L15.2777 15.8598L15.746 16.1708L16.6041 14.8896L16.1358 14.5786Z"
          fill="black"
        />
        <path
          d="M17.1507 13.0644L16.2917 14.345L16.7609 14.6566L17.619 13.3754L17.1507 13.0644Z"
          fill="black"
        />
        <path
          d="M16.8382 15.0445L15.9801 16.3258L16.4483 16.6352L17.3066 15.3542L16.8382 15.0445Z"
          fill="black"
        />
        <path
          d="M17.8531 13.5303L16.9948 14.8116L17.4633 15.1214L18.3214 13.8402L17.8531 13.5303Z"
          fill="black"
        />
        <path
          d="M17.5406 15.5093L16.6825 16.7906L17.1507 17.1005L18.0088 15.8203L17.5406 15.5093Z"
          fill="black"
        />
        <path
          d="M18.5544 13.9974L17.6968 15.2787L18.1656 15.5894L19.0232 14.3081L18.5544 13.9974Z"
          fill="black"
        />
        <path
          d="M9.65875 12.1326C10.434 12.6468 11.4821 12.4392 12 11.6667C12.5168 10.8942 13.5649 10.6865 14.3412 11.2008C15.1165 11.715 15.3263 12.7578 14.8095 13.5303C15.8432 11.9864 15.4246 9.90083 13.873 8.87122C12.3214 7.8416 10.2253 8.25916 9.1905 9.80303C8.67366 10.5755 8.88349 11.6172 9.65875 12.1326Z"
          fill="#EF1A24"
        />
        <path
          d="M10.127 14.4621C11.6786 15.4917 13.7747 15.0742 14.8095 13.5303C15.3263 12.7578 15.1165 11.715 14.3412 11.2008C13.566 10.6865 12.5168 10.8942 12 11.6667C11.4832 12.4392 10.4351 12.6468 9.65875 12.1326C8.88349 11.6183 8.67366 10.5755 9.1905 9.80303C8.15682 11.3469 8.57537 13.4325 10.127 14.4621Z"
          fill="#004186"
        />
      </g>
      <defs>
        <clipPath id="clip0_1813_1021">
          <rect
            width="20"
            height="15"
            fill="white"
            transform="translate(2 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SKor2424Icon;
